import { createSafeContainer } from '../../../../../../lib/utils/safe-container'

import { useProductDetails } from './useProductDetails'

/**
 * @deprecated Query for your own data as needed based on the URL. Or if on a page with initial SSR data like usePdpServerSideProps that has what you need already, use that.
 */
export const ProductDetailsContainer = createSafeContainer(useProductDetails)
